import { TrumpfUxConfig } from "./globals";
import { version } from "../../package.json";

export const CONFIG_DEFAULT: TrumpfUxConfig = {
    version: version,
    theme: "web",
    assetPath: "./themes/",
    logLevel: "warn",
    setLogLevel: (level: "debug" | "info" | "warn" | "error") => {
        if (typeof window !== "undefined") {
            const win = window as unknown as Window & {
                trumpf: {
                    ux: {
                        logLevel: "debug" | "info" | "warn" | "error";
                    };
                };
            };
            win.trumpf = win.trumpf || {};
            win.trumpf.ux = win.trumpf.ux || {};
            win.trumpf.ux.logLevel = level;
        }
    }
};
